// react
import React from 'react'
// constants (data | icon)
import { ourFeatures } from "../../../../constants/data"
import { OnTimeDeliveryIcon, QualityMattersIcon, ConveniantDeliveryIcon, CashOnDeliveryIcon, NotificationIcon, CCTVIcon } from "../../../../constants/icons"
import { Heading } from "../../../../components/UI";


// variables
const ourFeaturesIcon = [<OnTimeDeliveryIcon />, <QualityMattersIcon />, <ConveniantDeliveryIcon />, <CashOnDeliveryIcon />, <NotificationIcon />, <CCTVIcon />];

// FC: Features Component
const Features = () => {
  return (
    <main className="features | p-3 bg-primary-400">
      <section className="| flex-col gap-component my-container">
        <Heading className="text-white-900">Features</Heading>
        <ul className="features-grid | gap-2 m-0 my-container">
          {ourFeatures.length > 0 && ourFeatures.map((item, index) =>
            <li key={item.heading} className="our-feature-item | py-1 px-20 br-4 bg-primary-500 relative flex-col ai-center gap-8 relative pointer shadow-small">
              <span className="| aspect-ratio-1 circle p-1 bg-primary-600 text-white-900 fs-icon text-white-900 flex-center">{ourFeaturesIcon[index]}</span>
              <h1 className="| fw-600 text-white-800 text-center fs-list-item-heading" style={{ margin: 0 }}>{item.heading}</h1>
              <p className="| fw-400 text-white-700 text-center fs-list-item-text" style={{ margin: 0 }}>{item.description}</p>
            </li>
          )}
        </ul>
      </section>
    </main>
  )
}

export default Features